import thunk from 'redux-thunk';
import ReduxPromise from 'redux-promise';
import { createStore, applyMiddleware, compose } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';

import reducers from './reducers';
import { State as AppV2State } from './reducers/app.reducer';
import { LocalStorageKey } from 'common/helpers';

console.log('NODE_ENV:', process.env.NODE_ENV);
console.log('API:', process.env.REACT_APP_API);

let middleware = null;
if (process.env.NODE_ENV === 'production') {
  middleware = compose(applyMiddleware(ReduxPromise, thunk));
} else {
  middleware = composeWithDevTools(applyMiddleware(ReduxPromise, thunk));
}

const store = createStore(
  reducers,
  {
    appV2: {
      language: getStoredLanguage(),
    },
  },
  middleware
);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;

store.subscribe(() => {
  const { language } = store.getState().appV2;
  window.localStorage.setItem(LocalStorageKey.Language, language);
});

function getStoredLanguage(): AppV2State['language'] {
  const fromStorage = String(window.localStorage.getItem(LocalStorageKey.Language));
  return isValidLanguage(fromStorage) ? fromStorage : 'de';
}

function isValidLanguage(value: string): value is AppV2State['language'] {
  return ['en', 'de'].includes(value);
}
